<template>
  <div :class="{ fullSize: loading }">
    <div>
      <v-row
          justify="center"
          class="mt-2 titles"
          style="position: absolute; top: 4px; left: 40px; z-index: 1"
      >
        <v-icon color="primary" size="18" class="mr-2">fas fa-bug</v-icon>
        <p class="debug-page-title">Debugger</p>
      </v-row>

      <v-tabs
          v-model="tab"
          class="debugger-page-tabs"
          :background-color="$vuetify.theme.dark ? '#262B2E' : '#fff'"
          centered
          dark
          icons-and-text
          hide-slider
          height="60"
      >
        <v-tab
            @click="applicationTab"
            active-class="selectedTab"
            class="vTabClass"
        >
          Application
          <v-icon>mdi-phone</v-icon>
        </v-tab>

        <v-tab
            @click="showPGCards"
            active-class="selectedTab"
            class="vTabClass"
        >
          Price Guard
          <v-icon>mdi-heart</v-icon>
        </v-tab>

        <v-tab
            @click="showPGCards"
            active-class="selectedTab"
            class="vTabClass"
        >
          Recovery
          <v-icon>mdi-heart</v-icon>
        </v-tab>

        <v-tabs-items class="accent" v-model="tab">
          <v-tab-item>
            <loading-page v-if="loading"></loading-page>
            <div
                v-else
                flat
                :color="backgroundColor"
                style="
                overflow: hidden auto;
                height: calc(100vh - 120px) !important;
              "
            >
              <div>
                <v-row justify="center">
                  <div :style="debugCardWidth" class="ml-7 mt-4">
                    <v-row
                        style="display: -webkit-box; -webkit-box-align: center"
                    >
                      <p class="mb-0 mr-2">
                        {{ `Debugger ${debug ? "On" : "Off"}` }}
                      </p>
                      <v-switch
                          v-model="debug"
                          @change="debugStateChange"
                          color="primary"
                      ></v-switch>

                      <v-btn
                          @click="showMoreettings = !showMoreettings"
                          class="ml-0 mb-1 mr-1 ml-2"
                          style="margin-top: 2px"
                          icon
                          x-small
                      >
                        <v-icon
                            :color="showMoreettings ? 'primary' : 'white'"
                            small
                        >
                          fas fa-cog
                        </v-icon>
                      </v-btn>
                      <div v-if="showMoreettings">Interval (s)</div>
                      <div
                          v-if="showMoreettings"
                          class="ml-2"
                          style="width: 30px"
                      >
                        <v-text-field
                            dense
                            style="width: 20px !important; margin-bottom: -8px"
                            class="interval-field ml-2"
                            v-model.number="debugIntervalTime"
                            type="number"
                        ></v-text-field>
                      </div>
                      <v-btn
                          :fab="$vuetify.breakpoint.xsOnly"
                          v-if="showMoreettings"
                          @click="setIntervalTime"
                          :class="$vuetify.breakpoint.xsOnly ? 'ml-4' : 'ml-6'"
                          color="primary"
                          small
                      >
                        ok
                      </v-btn>
                    </v-row>
                  </div>
                </v-row>
              </div>
              <v-row justify="center">
                <v-card
                    :style="debugCardWidth"
                    class="debug-card pa-3 pl-4"
                    style="display: inline-block; margin-top: -16px"
                >
                  <v-row
                  >
                    <div class="ml-2">Status:</div>
                    <div :class="`${statusColor}--text`" class="ml-2">
                      {{ debugData.status }}
                    </div>
                  </v-row
                  >

                  <p class="mt-2">Messages: {{ debugData.numOfMessages }}</p>
                  <p>Exceptions: {{ debugData.numOfExceptions }}</p>
                  <p>
                    Last message at: {{ debugData.lastMessageTimestamp }}
                    {{
                      debugData.lastMessageTimestamp > 0
                          ? "(" +
                          new Date(
                              debugData.lastMessageTimestamp
                          ).toLocaleString() +
                          ")"
                          : ""
                    }}
                  </p>
                  <p v-if="debugData.totalProcessingTime / 1000 < 1">
                    Total Processing time:
                    {{ debugData.totalProcessingTime + "ms" }}
                  </p>
                  <p v-else>
                    Total Processing time:
                    {{
                      debugData.totalProcessingTime / 1000 > 60
                          ? calculateTime(
                              debugData.totalProcessingTime + Date.now()
                          )
                          : debugData.totalProcessingTime / 1000 + "s"
                    }}
                  </p>

                  <p v-if="debugData.averageProcessingTime / 1000 < 1">
                    Average Processing time:
                    {{ debugData.averageProcessingTime + "ms" }}
                  </p>
                  <p v-else>
                    Average Processing time:
                    {{
                      debugData.averageProcessingTime / 1000 > 60
                          ? calculateTime(
                              debugData.averageProcessingTime + Date.now()
                          )
                          : debugData.averageProcessingTime / 1000 + "s"
                    }}
                  </p>

                  <p>Last Topic Message: {{ debugData.lastTopicMessage }}</p>
                  <p>Last Topic Publisher: {{ debugData.lastPublisher }}</p>
                  <v-tooltip :disabled="$vuetify.breakpoint.xsOnly" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                          v-on="on"
                          @click="resetMetrics"
                          style="
                          font-size: 17px !important;
                          position: absolute;
                          top: 14px;
                          right: 11px;
                        "
                          class="primary--text"
                      >fas fa-redo-alt
                      </v-icon
                      >
                    </template>
                    <span>Reset Metrics</span>
                  </v-tooltip>
                  <v-progress-linear
                      :class="{ showLenear: debug }"
                      indeterminate
                      color="primary"
                      class="loading-animation"
                  ></v-progress-linear>
                </v-card>
              </v-row>
              <v-row justify="center">
                <v-card
                    :style="debugCardWidth"
                    class="debug-card pa-3 pl-4 mt-9"
                    style="display: inline-block; margin-top: -16px"
                >
                  <v-row>
                    <v-icon small class="ml-5 mt-1" style="margin-bottom: 2px"
                    >far fa-clock
                    </v-icon
                    >
                    <p class="mb-0 ml-2 mt-1">Scheduler</p>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-select
                          :menu-props="{ offsetY: true }"
                          :items="executionTypes"
                          :color="$vuetify.theme.dark ? 'primary' : 'secondary'"
                          v-model="executionType"
                          label="Execution Type"
                          hide-details=""
                          dark
                          outlined
                          dense
                          class="pa-2"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                          :color="$vuetify.theme.dark ? 'primary' : 'secondary'"
                          hide-details=""
                          v-model.number="schedulerInterval"
                          label="Scheduler Interval (ms)"
                          type="number"
                          dark
                          dense
                          outlined
                          class="pa-2"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="updateScheduler" color="primary">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-row class="mx-0">
              <div style="max-width: 280px">
                <v-select
                    :disabled="loadingPGStatistics"
                    v-model="PGServerSelected"
                    :items="PGServers"
                    @change="PGServerChanged"
                    :menu-props="{ offsetY: true, maxHeight: '250' }"
                    label="Select server"
                    dense
                    class="mx-4 mt-3 mb-2 pl-2 pt-2"
                    hide-details
                >
                  <template v-slot:item="{ item }">
                    <div class="mb-0 char-lim-tabs dense-select-item">
                      <div>{{ item }}</div>
                    </div>
                  </template>
                </v-select>
              </div>

              <div style="max-width: 250px">
                <v-text-field
                    v-model="search"
                    @keydown="filterCards"
                    :disabled="loadingPGStatistics"
                    :rules="regexSearch ? [rules.validRegex] : []"
                    dark
                    dense
                    :color="$vuetify.theme.dark ? 'primary' : 'secondary'"
                    append-icon="search"
                    :placeholder="regexSearch ? 'Search with regex' : 'Search'"
                    single-line
                    hint="Press enter to search"
                    style="margin-top: 10px"
                >
                  <template v-slot:append>
                    <v-btn @click.stop="switchRegex" icon small class="mb-2">
                      <div
                          :key="regexBtnRenderKey"
                          :class="regexSearch ? 'primary--text' : 'white--text'"
                          class="absolute"
                          style="left: 12px; font-size: 17px"
                      >
                        *
                      </div>
                      <div
                          :class="regexSearch ? 'primary--text' : 'white--text'"
                          class="absolute"
                          style="left: 5px; font-size: 25px; margin-bottom: 2px"
                      >
                        .
                      </div>
                    </v-btn>
                    <v-btn
                        @click.stop="showSearchBy = !showSearchBy"
                        icon
                        x-small
                        class="mt-2"
                    >
                      <v-icon :color="showSearchBy ? 'primary' : 'white'" small
                      >fas fa-cog
                      </v-icon
                      >
                    </v-btn>
                  </template>
                </v-text-field>
              </div>

              <div v-if="showSearchBy" style="max-width: 200px">
                <!-- @change="PGServerChanged" -->
                <v-select
                    :disabled="loadingPGStatistics"
                    v-model="searchBy"
                    :items="searchByItems"
                    :menu-props="{ offsetY: true, maxHeight: '250' }"
                    :label="`Search ${searchBy}`"
                    dense
                    class="mx-4 mt-3 mb-2 pl-2 pt-2"
                    hide-details
                >
                  <template v-slot:item="{ item }">
                    <div class="mb-0 char-lim-tabs dense-select-item">
                      <div>{{ item }}</div>
                    </div>
                  </template>
                </v-select>
              </div>

              <v-spacer></v-spacer>
              <v-tooltip :disabled="$vuetify.breakpoint.xsOnly" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                      @click="refreshPGStatistics"
                      v-on="on"
                      :disabled="loadingPGStatistics"
                      rounded
                      class="primary reset-btn mt-3 mr-6"
                      icon
                      text
                      width="28"
                      height="28"
                  >
                    <v-icon style="font-size: 16px">fas fa-redo-alt</v-icon>
                  </v-btn>
                </template>
                <span>
                  <p class="mb-0">Refresh</p>
                  <p
                      v-if="lastRefresh && !loadingPGStatistics"
                      class="mb-0 mt-1 mr-2"
                      style="font-size: 14px"
                  >
                    Last refresh : {{ lastRefresh }}
                  </p>
                </span>
              </v-tooltip>
            </v-row>
            <div
                id="pg-cards-wrapper"
                style="overflow-y: auto; overflow-x: hidden"
            >
              <loading-page v-if="loadingPGStatistics"></loading-page>
              <v-row
                  v-else-if="showNoDataText"
                  justify="center"
                  class="mx-1"
                  style="height: 100%"
              >
                <v-col cols="12">
                  <v-row align="center" justify="center" style="height: 100%">
                    {{ noDataText }}
                  </v-row>
                </v-col>
              </v-row>
              <v-row id="cardsContainer" v-else class="mx-1">
                <!-- <v-col id="TopScroll" cols="0"></v-col> -->
                <v-col
                    v-for="card in PGCards"
                    :key="card.key"
                    style="padding-left: 8px; padding-right: 8px"
                    lg="3"
                    md="4"
                    sm="6"
                    cols="12"
                >
                  <v-lazy
                      :options="{
                      threshold: 0.1,
                    }"
                      min-height="200"
                      transition="fade-transition"
                      :value="false"
                  >
                    <priceguard-statistics-card
                        :card="card"
                        @show-more="card.showMore = true"
                        @show-less="card.showMore = false"
                    />
                  </v-lazy>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-row class="mx-0" justify="center">
              <Recovery/>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>
<script>
import {DebugService} from "@/services/ApiService";
import {LoadingPage} from "../components/Default-Page-Components";
import PriceguardStatisticsCard from "../components/Debugger/PriceguardStatisticsCard.vue";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import {mapGetters} from "vuex";
import Recovery from "@/components/Debugger/Recovery.vue";

export default {
  name: "Debugger",
  components: {Recovery, LoadingPage, PriceguardStatisticsCard},
  data: () => ({
    schedulerInterval: null,
    executionType: "FIXED_DELAY",
    executionTypes: [
      {value: "FIXED_DELAY", text: "Fixed Delay"},
      {value: "FIXED_RATE", text: "Fixed Rate"},
    ],
    showSearchBy: false,
    searchBy: "Symbol",
    searchByItems: [
      "Symbol",
      "Identity",
      "Status",
      "Insert Time",
      "Timestamp",
      "Datetime",
      "Expires In",
    ],
    loadingPGStatistics: false,
    lastRefresh: null,
    regexBtnRenderKey: 0,
    regexSearch: false,
    rules: {
      validRegex: (regexStr) => {
        var isValid = true;
        try {
          new RegExp(regexStr);
        } catch (e) {
          isValid = false;
        }
        return isValid || "Invalid regular expression";
      },
    },
    search: null,
    PGServerSelected: null,
    PGServers: [],
    PGCards: [],
    PGStatistics: {},
    tab: null,
    debugInterval: null,
    debugIntervalTime: 3,
    debug: false,
    showMoreettings: false,
    debugData: null,
    loading: false,
    refreshingData: false,
  }),
  props: {
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push("/");
    }
    this.loading = true;
    this.fetchDebugInfo();

    TimeAgo.addLocale(en);
    // Create relative date/time formatter.
    this.timeAgo = new TimeAgo("en-US");

    this.debugInterval = setInterval(this.refreshDebugData, 3000);
  },
  beforeDestroy() {
    clearInterval(this.debugInterval);
  },
  methods: {
    getSchedulerParams() {
      if (!this.schedulerInterval) {
        this.$notifier.error(
            this.schedulerInterval == null
                ? "Please set Scheduler Interval"
                : "Error occurred. Please check scheduler interval"
        );
        return null;
      }
      return {
        executionType: this.executionType,
        schedulerInterval: this.schedulerInterval,
      };
    },
    updateScheduler() {
      let params = this.getSchedulerParams();
      if (!params) return;
      DebugService.Scheduler.post(params)
          .then(() => {
            this.$notifier.success("Scheduler updated successfully!");
          })
          .catch((error) => {
            this.$notifier.error(error.response.data.message, {error: error});
            console.error(error);
          });
    },
    getSearchByField() {
      let str = "Symbol";
      switch (this.searchBy) {
        case "Insert Time":
          str = "insertTime";
          break;
        case "Timestamp":
          str = "timestampInMillis";
          break;
        case "Expires In":
          str = "expires_at";
          break;
        default:
          str = this.searchBy.charAt(0).toLowerCase() + this.searchBy.slice(1);
      }
      return str;
    },
    getCurrentTimeAMPM() {
      let today = new Date();
      let hours = today.getHours();
      let mins = today.getMinutes();
      let secs = today.getSeconds();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      mins = mins < 10 ? "0" + mins : mins;
      var strTime = hours + ":" + mins + ":" + secs + " " + ampm;
      return strTime;
    },
    parseServers(servers) {
      let currentEpochTime = Date.now();

      let serverNames = Object.keys(servers);
      serverNames.forEach((server) => {
        servers[server] = servers[server].map((el) => {
          el.showMore = false;
          el.expires_at = this.calculateTime(
              currentEpochTime + el.expires_at * 1000,
              "< 1m"
          );
          el.insertTime = new Date(el.insertTime * 1000).toLocaleString();
          el.datetime = new Date(el.datetime * 1000).toLocaleString();
          el.timestampInMillis = new Date(
              el.timestampInMillis
          ).toLocaleString();
          return el;
        });
      });

      // return parsedData
    },
    rerenderRegexBtn() {
      if (this.regexBtnRenderKey < 10) this.regexBtnRenderKey++;
      else this.regexBtnRenderKey = 0;
    },
    applicationTab() {
      this.PGServerSelected = null;
      this.currentTab = 0;
      this.PGCards = [];
    },
    PGServerChanged(serverName) {
      if (
          !serverName ||
          (typeof serverName == "string" &&
              !this.PGStatistics.hasOwnProperty(serverName))
      )
        return;
      let cards = this.PGStatistics[serverName];
      if (cards) this.PGCards = cards;
      // this.scrollToFirstCard()
    },
    switchRegex() {
      this.regexSearch = !this.regexSearch;
      this.rerenderRegexBtn();
      if (!this.regexSearch) this.regex = null;
    },
    validateRegex(regexStr, returnRegex = true) {
      var isValid = true;
      try {
        var regex = new RegExp(regexStr);
      } catch (e) {
        isValid = false;
      }

      if (returnRegex && regex != undefined) {
        return regex;
      } else return isValid;
    },
    filterCards(ev, forceFilter = false) {
      let onlyFilterByServer = this.search == null;

      if (
          (ev.key != "Enter" && !forceFilter) ||
          (this.search == null && !forceFilter) ||
          !this.PGServerSelected ||
          !Object.keys(this.PGStatistics).length
      )
        return;
      let cards = this.PGStatistics[this.PGServerSelected];
      if (onlyFilterByServer) {
        this.PGCards = cards;
      } else {
        let searchBy = this.getSearchByField();
        let regexSearch = (el) => regex.test(el[searchBy]);
        let normalSearch = (el) => el[searchBy].indexOf(this.search) !== -1;

        if (this.regexSearch) {
          var regex = this.validateRegex(this.search);
          if (regex) {
            this.PGCards = cards.filter(regexSearch);
          }
        } else {
          this.PGCards = cards.filter(normalSearch);
        }
      }
    },
    refreshPGStatistics() {
      this.fetchPGStatistics(true);
    },
    fetchPGStatistics(applyFiltering = false) {
      this.loadingPGStatistics = true;
      DebugService.Statistics.Priceguard.get()
          .then((response) => {
            this.lastRefresh = this.getCurrentTimeAMPM();

            if (response && response.data) {
              // Parse Time & dates
              let servers = response.data;
              this.parseServers(servers);

              this.PGServers = Object.keys(servers);
              this.PGStatistics = servers;

              let selectedServerExists = this.PGServers.includes(
                  this.PGServerSelected
              );

              if (applyFiltering && selectedServerExists) {
                this.filterCards({}, true);
              }
              if (!selectedServerExists) this.PGServerSelected = null;
            }

            this.loadingPGStatistics = false;

            // this.scrollToFirstCard()
          })
          .catch((error) => {
            this.loadingPGStatistics = false;
            console.error(error);
            this.$notifier.error("Couldn't fetch Price Guard statistics!");
          });
    },
    showPGCards() {
      if (this.currentTab == 1) return;
      this.currentTab = 1;

      this.fetchPGStatistics();
    },
    setIntervalTime() {
      clearInterval(this.debugInterval);
      let intervalTime = this.debugIntervalTime ? this.debugIntervalTime : 3;
      this.debugInterval = setInterval(
          this.refreshDebugData,
          intervalTime * 1000
      );
    },
    refreshDebugData() {
      if (!this.refreshingData) {
        this.refreshingData = true;
        this.fetchDebugInfo();
      }
    },
    calculateTime(date) {
      let soonText = "just now";
      let elapsedTime = this.timeAgo.format(date, "twitter");
      if (elapsedTime.length < 4 && elapsedTime.includes("s")) {
        return soonText;
      } else {
        return elapsedTime;
      }
    },
    fetchDebugInfo() {
      DebugService.ApplicationEventHandler.get()
          .then((response) => {
            this.debugData = response.data;
            if (this.debugData.status == "RUNNING") {
              this.debug = true;
            } else {
              this.debug = false;
            }
            this.loading = false;
            this.refreshingData = false;
          })
          .catch((error) => {
            console.error(error);
            this.$notifier.error(error.response.data.message, {error: error});
            this.loading = false;
            this.refreshingData = false;
          });
    },
    resetMetrics() {
      DebugService.ApplicationEventHandler.reset()
          .then((response) => {
            this.fetchDebugInfo();
          })
          .catch((error) => {
            this.fetchDebugInfo();
            console.error(error);
            this.$notifier.error(error.response.data.message, {error: error});
          });
    },
    debugStateChange(ev) {
      ev ? this.runDebugger() : this.stopDebugger();
    },
    runDebugger() {
      this.changeDebuggerState("START");
    },
    stopDebugger() {
      this.changeDebuggerState("STOP");
    },
    changeDebuggerState(slug) {
      DebugService.ApplicationEventHandler.post(slug)
          .then((response) => {
            this.fetchDebugInfo();
          })
          .catch((error) => {
            this.fetchDebugInfo();
            this.debug = slug == "STOP";
            console.error(error);
            this.$notifier.error(error.response.data.message, {error: error});
          });
    },
  },
  // props: {},
  computed: {
    showNoDataText() {
      return !this.PGCards.length || !this.PGServerSelected;
    },
    noDataText() {
      let text;
      if (!this.PGServers) text = "No cards to show";
      else if (!this.PGServerSelected)
        text = "Statistics loaded, select a server.";
      return text;
    },
    debugCardWidth() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return "width: 350px;";
      }
      return "width: 700px;";
    },
    statusColor() {
      if (!this.debugData) return "red";
      else {
        switch (this.debugData.status) {
          case "CANCELED":
          case "DONE":
            return "red";
          case "NONE":
            return "yellow";
          case "RUNNING":
            return "primary";
        }
        return "red";
      }
    },
    cardBackgroundColor() {
      return this.$vuetify.theme.dark ? "#1d2325" : "#fff";
    },
    backgroundColor() {
      return this.$vuetify.theme.dark ? "#262b2e" : "#fff";
    },
    backgroundColorReverse() {
      return this.$vuetify.theme.dark ? "#fff" : "#262b2e";
    },
    isMobileOrTablet() {
      return navigator.userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
      ) == null
          ? false
          : true;
    },
    ...mapGetters(["isAdmin"]),
  },
};
</script>

<style>
#pg-cards-wrapper {
  height: calc(100vh - 190px) !important;
  width: 100%;
}

.theme--light .vTabClass {
  color: rgb(0, 0, 0, 0.67) !important;
}

.theme--dark .vTabClass i {
  color: #47bd96 !important;
}

.interval-field input {
  width: 35px;
}

.interval-field .v-text-field__slot {
  width: 35px;
}

.interval-field .v-input__slot {
  width: 35px;
}

.interval-field .v-input__control {
  width: 35px;
}

.showLenear {
  opacity: 1 !important;
}

.loading-animation {
  position: absolute;
  bottom: -1px;
  left: 0;
  opacity: 0;
  transition: all 0.5s;
}

.debug-page-title {
  width: 134px;
  height: 22px;
  font-family: Dosis;
  font-size: 22px !important;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-top: 6px;
}

.debugger-tabs .theme--dark.v-tabs-items {
  background: transparent;
}

.debug-card p {
  margin-bottom: 4px;
}

.debugger-page-tabs p,
div {
  letter-spacing: 0.015rem;
}
</style>
